import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import DownloaderDemo from './DownloaderDemo'
import DownloaderElement from './DownloaderElement'
import DownloaderFormBrand from './DownloaderFormBrand'
import { STYLE_FORM_SCHEMA } from './DownloaderFormStyle'
import DownloaderFormValue from './DownloaderFormValue'
import downloaderIcon from './assets/downloader.svg'

export default genElementConfig(CONFIG_ELEMENTS.downloader, {
  label: t('elements.downloader.label'),
  group: ElementGroup.interactive,
  icon: downloaderIcon,
  styleFields: STYLE_FORM_SCHEMA,
  Element: DownloaderElement,
  Demo: [DownloaderDemo],
  FormValue: DownloaderFormValue,
  FormBrand: DownloaderFormBrand,
  EditorActions: null,
})
